var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ui-logout",on:{"click":_vm.handleClick}},[_c('ui-icon',{attrs:{"size":"18","color":_vm.$colors.white,"icon":"fas fa-sign-out-alt"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }